__turbopack_context__.v({
  "cta": "box-cta-module-scss-module__8dtQkG__cta",
  "destructive": "box-cta-module-scss-module__8dtQkG__destructive",
  "large": "box-cta-module-scss-module__8dtQkG__large",
  "loading": "box-cta-module-scss-module__8dtQkG__loading",
  "medium": "box-cta-module-scss-module__8dtQkG__medium",
  "neutral-filled": "box-cta-module-scss-module__8dtQkG__neutral-filled",
  "neutral-outline": "box-cta-module-scss-module__8dtQkG__neutral-outline",
  "neutral-tonal": "box-cta-module-scss-module__8dtQkG__neutral-tonal",
  "primary": "box-cta-module-scss-module__8dtQkG__primary",
  "slot": "box-cta-module-scss-module__8dtQkG__slot",
  "small": "box-cta-module-scss-module__8dtQkG__small",
  "text": "box-cta-module-scss-module__8dtQkG__text",
  "wide": "box-cta-module-scss-module__8dtQkG__wide",
});
